import { render, staticRenderFns } from "./FooterMenuItem.vue?vue&type=template&id=532f6f26"
import script from "./FooterMenuItem.vue?vue&type=script&lang=js"
export * from "./FooterMenuItem.vue?vue&type=script&lang=js"
import style0 from "./FooterMenuItem.vue?vue&type=style&index=0&id=532f6f26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports